// let mainData = {
//     famous: "http://127.0.0.1:8000/cat/",
//     recent: "http://127.0.0.1:8000/trending/",
//     editorsPick: "http://127.0.0.1:8000/editorsPick/",
//     popular: "http://127.0.0.1:8000/popular/",
//     randomCateogary: "http://127.0.0.1:8000/random/",
//     recentBlogs: "http://127.0.0.1:8000/recent/",
//     cateogaries: "http://127.0.0.1:8000/cat/",
//     searchByCateogary: "http://127.0.0.1:8000/cateogary/",
//     searchByPost: "http://127.0.0.1:8000/posts/",
//     searchByHashtag: "http://127.0.0.1:8000/hashtags/",
//     likeThePost: "http://127.0.0.1:8000/likes/",
//     allBlogPost: "http://127.0.0.1:8000/all/",
//     aboutAuthor: "http://127.0.0.1:8000/about/",
//     search: "http://127.0.0.1:8000/search/",
//     randomSearchCateogary: "http://127.0.0.1:8000/randomCateogary/",
//     contact: "http://127.0.0.1:8000/contact/",
//     newsletter: "http://127.0.0.1:8000/newsletter/",
//     getComments: "http://127.0.0.1:8000/getComments/",
//     commentPost: "http://127.0.0.1:8000/comments/",
//     nextPost: "http://127.0.0.1:8000/nextPost/",
//     prevPost: "http://127.0.0.1:8000/prevPost/",
//     hashsearch: "http://127.0.0.1:8000/hashtagsearch/",
//     headsearch: "http://127.0.0.1:8000/headlinesearch/",
//     catsearch: "http://127.0.0.1:8000/catsearch/",
// };

let mainData = {
    famous: "https://blogx.pythonanywhere.com/cat/",
    recent: "https://blogx.pythonanywhere.com/trending/",
    editorsPick: "https://blogx.pythonanywhere.com/editorsPick/",
    popular: "https://blogx.pythonanywhere.com/popular/",
    randomCateogary: "https://blogx.pythonanywhere.com/random/",
    recentBlogs: "https://blogx.pythonanywhere.com/recent/",
    cateogaries: "https://blogx.pythonanywhere.com/cat/",
    searchByCateogary: "https://blogx.pythonanywhere.com/cateogary/",
    searchByPost: "https://blogx.pythonanywhere.com/posts/",
    searchByHashtag: "https://blogx.pythonanywhere.com/hashtags/",
    likeThePost: "https://blogx.pythonanywhere.com/likes/",
    allBlogPost: "https://blogx.pythonanywhere.com/all/",
    aboutAuthor: "https://blogx.pythonanywhere.com/about/",
    search: "https://blogx.pythonanywhere.com/search/",
    randomSearchCateogary: "https://blogx.pythonanywhere.com/randomCateogary/",
    contact: "https://blogx.pythonanywhere.com/contact/",
    newsletter: "https://blogx.pythonanywhere.com/newsletter/",
    getComments: "https://blogx.pythonanywhere.com/getComments/",
    commentPost: "https://blogx.pythonanywhere.com/comments/",
    nextPost: "https://blogx.pythonanywhere.com/nextPost/",
    prevPost: "https://blogx.pythonanywhere.com/prevPost/",
    hashsearch: "https://blogx.pythonanywhere.com/hashtagsearch/",
    headsearch: "https://blogx.pythonanywhere.com/headlinesearch/",
    catsearch: "https://blogx.pythonanywhere.com/catsearch/",
};

// if (process.env.NODE_ENV === "development") {

// }
// if (process.env.NODE_ENV === "production") {

// }

export default mainData